"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var redux_saga_1 = require("redux-saga");
var actions = __importStar(require("./actions"));
var api_1 = require("../api");
var actions_1 = require("./actions");
function createCheckPaymentChannel(key, maxRetry) {
    var _this = this;
    var retry = 0;
    return (0, redux_saga_1.eventChannel)(function (emitter) {
        var iv = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var response, e_1, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retry++;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, (0, api_1.checkPaymentRequest)({ key: key })];
                    case 2:
                        response = _a.sent();
                        if (response.status == 'accepted' || response.status == 'canceled') {
                            emitter(response);
                            emitter(redux_saga_1.END);
                        }
                        emitter(response);
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        data = { key: key, 'status': 'canceled' };
                        emitter(data);
                        emitter(redux_saga_1.END);
                        return [3, 4];
                    case 4:
                        if (retry >= maxRetry) {
                            emitter({ key: key, 'status': 'canceled' });
                            emitter(redux_saga_1.END);
                        }
                        return [2];
                }
            });
        }); }, 5000);
        return function () {
            clearInterval(iv);
        };
    });
}
function checkPayment(action) {
    var maxRetry, chan;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                maxRetry = 30;
                return [4, (0, effects_1.call)(createCheckPaymentChannel, action.key, maxRetry)];
            case 1:
                chan = _a.sent();
                return [4, (0, effects_1.takeEvery)(chan, function (data) {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(data.status == 'accepted')) return [3, 2];
                                    return [4, (0, effects_1.put)((0, actions_1.checkPaymentSuccess)(data))];
                                case 1:
                                    _a.sent();
                                    return [3, 4];
                                case 2:
                                    if (!(data.status == 'canceled' || data.status == 'refund')) return [3, 4];
                                    return [4, (0, effects_1.put)((0, actions_1.checkPaymentFail)())];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4: return [2];
                            }
                        });
                    })];
            case 2:
                _a.sent();
                return [2];
        }
    });
}
function paymentsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, (0, effects_1.takeEvery)(actions.CHECK_PAYMENT, checkPayment)];
            case 1:
                _a.sent();
                return [2];
        }
    });
}
exports.default = paymentsSaga;
